import { Datepicker } from 'flowbite'

Datepicker.prototype._getDatepickerOptions = function (options) {
  var datepickerOptions = {}
  if (options.buttons) {
    datepickerOptions.todayBtn = true
    datepickerOptions.clearBtn = true
    if (options.autoSelectToday) {
      datepickerOptions.todayBtnMode = 1
    }
  }
  if (options.autohide) {
    datepickerOptions.autohide = true
  }
  if (options.format) {
    datepickerOptions.format = options.format
  }
  if (options.maxDate) {
    datepickerOptions.maxDate = options.maxDate
  }
  if (options.minDate) {
    datepickerOptions.minDate = options.minDate
  }
  if (options.orientation) {
    datepickerOptions.orientation = options.orientation
  }
  if (options.title) {
    datepickerOptions.title = options.title
  }
  if (options.language) {
    datepickerOptions.language = options.language
  }
  // Portaled pickers only re-place themselves on resize, so one anchored to a sticky element
  // must render in place instead. Opt in per input with data-datepicker-container.
  var explicitContainer = this._datepickerEl.dataset.datepickerContainer
  var modalContainer = this._datepickerEl.closest('#flowbite_modal_pickers')
  datepickerOptions.container =
    explicitContainer ||
    (modalContainer ? '#flowbite_modal_pickers' : '#flowbite_container_pickers')
  datepickerOptions.todayHighlight = true
  if (document.body.classList.contains('finance-page')) {
    datepickerOptions.updateOnBlur = false
    datepickerOptions.showOnFocus = false
  }
  return datepickerOptions
}
